(function () {
    angular.module('tmx-app').directive("tmxTextbox", tmxTextBox);

    function tmxTextBox() {
        // this.restrict=userInputRestrictions;
        return {
            scope: {
                type: '@',
                label: '@',
                value: '=',
                name: '@',
                maxlength: '@',
                minlength: '@',
                required: '=',
                form: '=',
                pattern: '@',
                readonly: '@',
                disabled: '=',
                search: '@',
                filter: '@',
                min: '@',
                max: '@',
                validation: '@',
                clearable: '@',
                mask: '@',
                autofocus: '=',
                dynamicField: '=',
                dynamicShow: '=',
                onKeyDown: '&',
                precision: '@',
                showCustomMessage: '=',
                formula: '@',
                hasFormula: '@',
                hasDisabledExpression: '@',
                customMask: '@',
                showMaxLength: '@',
                multiline: '@',
                helpText: '@',
                patternName: '@',
                usePattern: '='
            },
            restrict: 'E',
            require: 'ngMessages',
            priority: 100,
            templateUrl: 'common/directives/tmxtextbox/tmxtextbox.html',
            controller: tmxTextBoxCtrl,
            controllerAs: 'textboxCtrl'
        };
    }

    function tmxTextBoxCtrl($scope, $element, $attrs, userInputRestrictions, $filter, $window) {
        var textboxCtrl = this;
        textboxCtrl.scope = $scope;
        textboxCtrl.validation = true;
        textboxCtrl.fff = false;
        textboxCtrl.hasSpecialHandling = false;
        setupLengths($scope, textboxCtrl);
        if (textboxCtrl.scope.usePattern == undefined || textboxCtrl.scope.usePattern == null) {
            textboxCtrl.scope.usePattern = true;
        }
        if (angular.isUndefined(textboxCtrl.scope.customMask) || textboxCtrl.scope.customMask.length <= 0) {
            delete textboxCtrl.scope.customMask;
        }
        if ($scope.type == "cnic") {
            $scope.type = "text";
            $scope.customMask = "99999-9999999-9";
        }
        else if ($scope.type == "phone") {
            $scope.type = "text";
            $scope.customMask = "+9999999?9?9?9?9?9?9?9?9?9?9?9?9?9?";
        }
        else if ($scope.type == "rangenumber") {
            $scope.type = "number";
        }
        if ($scope.label == "Capacity") {
            $scope.helpText = "Note: If you are not the Account Holder please indicate the capacity in which you are signing the form.If signing under a power of attorney please also attach a certified copy of the power of attorney.";
            $scope.value = $scope.value ? $scope.value : 'Not Applicable'
        }
        if (!angular.isDefined(textboxCtrl.scope.mask)) {
            textboxCtrl.scope.mask = false;
            textboxCtrl.scope.uiplaceholder = false;
            textboxCtrl.scope.uiplaceholderchar = false;
        }
        else if (textboxCtrl.scope.mask == 'false') {
            textboxCtrl.scope.mask = false;
            textboxCtrl.scope.uiplaceholder = false;
            textboxCtrl.scope.uiplaceholderchar = false;
        }
        else {
            textboxCtrl.scope.uiplaceholder = true;
            textboxCtrl.scope.uiplaceholderchar = " ";
        }

        if (!angular.isDefined(textboxCtrl.scope.clearable)) {
            textboxCtrl.scope.clearable = false;
        }
        else {
            if (textboxCtrl.scope.clearable == 'true')
                textboxCtrl.scope.clearable = true;
        }
        if (angular.isDefined(textboxCtrl.scope.validation)) {
            if (textboxCtrl.scope.validation == "false") {
                textboxCtrl.validation = false;
            }
        }
        textboxCtrl.readonly = false;
        if (angular.isDefined(textboxCtrl.scope.readonly)) {
            if (textboxCtrl.scope.readonly == "true") {
                textboxCtrl.readonly = true;
            }
        }
        if (!angular.isDefined(textboxCtrl.scope.type)) {
            textboxCtrl.scope.type = "text";
        }

        if (textboxCtrl.scope.showMaxLength === true && angular.isDefined(textboxCtrl.scope.maxlength)) {
            textboxCtrl.scope.showMaxLength = true;
        }
        else {
            textboxCtrl.scope.showMaxLength = false;
        }

        if (textboxCtrl.scope.type == "amount") {
            textboxCtrl.hasSpecialHandling = true;
        }

        if(angular.isDefined(textboxCtrl.scope.form) && angular.isDefined(textboxCtrl.scope.name)){
            if(textboxCtrl.scope.form[textboxCtrl.scope.name]){
                textboxCtrl.scope.form[textboxCtrl.scope.name].$error = {};
            }
        }

        // if(angular.isDefined(textboxCtrl.scope.compare) && textboxCtrl.scope.compare!=null && textboxCtrl.scope.compare!="")
        // {
        // 	textboxCtrl.scope.compareWith = textboxCtrl.scope.compare;
        // }


        textboxCtrl.clear = function () {
            textboxCtrl.scope.value = "";
        };

        textboxCtrl.openInMap = function () {
            if (textboxCtrl.scope.value != null && textboxCtrl.scope.value != undefined && textboxCtrl.scope.value.trim() != "") {
                $window.open('https://www.google.com/maps/search/?api=1&query=' + textboxCtrl.scope.value, '_blank');
            }
        }

        textboxCtrl.captureLocation = function () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition);
            }
            else {
                textboxCtrl.scope.value = "Not supported";
                console.log("Geolocation is not supported by this browser.");
            }
            function showPosition(position){
                textboxCtrl.scope.value = `${position.coords.latitude},${position.coords.longitude}`
            }
        }

        /*		textboxCtrl.onChange = function(newA,oldA){
                    if(newA!==oldA){
                        textboxCtrl.scope.onKeyDown( {value : newA} );
                    }
                    if(angular.isDefined(textboxCtrl.scope.max) && textboxCtrl.scope.max!=null)
                    {
                        if(angular.isDefined(textboxCtrl.scope.value) && textboxCtrl.scope.value!=null)
                        {
                            if(textboxCtrl.scope.value.length > textboxCtrl.scope.maxlength)
                            {
                                textboxCtrl.scope.value.slice(0,textboxCtrl.scope.maxlength);
                            }
        
                        }
                    }
                };*/
        function getValue() {

            return textboxCtrl.scope.value;
        }

		/*textboxCtrl.onblur=function(item){
			if(angular.isFunction($scope.onBlur())){
				$scope.onBlur()($scope.value,$scope);
			}
		}*/
        textboxCtrl.onchange = function (newvalue, oldvalue) {

            /*if($scope.dynamicField.id==1961){
            }*/
            if (newvalue == oldvalue || $scope.selfchange) {
                $scope.selfchange = false;
                return;
            }
            if (angular.isDefined(textboxCtrl.scope.form) && angular.isDefined(textboxCtrl.scope.form[textboxCtrl.scope.name]) &&
                (textboxCtrl.scope.form[textboxCtrl.scope.name].$name === "Disability Nature" ||
                    textboxCtrl.scope.form[textboxCtrl.scope.name].$name === "Training Specifications")) {
                decideValidity();
            }

            // Show Error If Pattern Not Match
            if (!$scope.dynamicField) {
                let valid = decideValidity();
                if(!valid){
                    return;
                }
            }

            // Clear Textbox If Pattern Not Match
            // if($scope.value && $scope.value.match && angular.isDefined($scope.pattern) && $scope.pattern!=null && $scope.pattern.length>0){// if has a pattern associated then check if the new key pressed is valid
            // 	var match=$scope.value.match($scope.regex);
            // 	if(!match || match[0]!=$scope.value){
            // 		$scope.value=$scope.lastValidValue;
            // 		$scope.selfchange=true;
            // 		return;
            // 	}
            // }

            $scope.lastValidValue = $scope.value
            textboxCtrl.scope.onKeyDown({ value: textboxCtrl.scope.value, scope: textboxCtrl.scope });
        };
        ///////////////////////////////////// MOVED FROM TEXTBOX_PROV///////////////////////////////////////////////////////////
        $scope.$watch(getValue, textboxCtrl.onchange);
        //////////////////CHECK FOR IF REQUIRED VALUE IS ENTERED////////////////////////////////////

        function getrequiredValue() {

            return textboxCtrl.scope.required;
        }
        textboxCtrl.onreqchange = function (nv, ov) {

            if (nv == ov) return;

            textboxCtrl.scope.required = nv;
            if (angular.isDefined(textboxCtrl.scope.form) && angular.isDefined(textboxCtrl.scope.form[textboxCtrl.scope.name]) &&
                (textboxCtrl.scope.form[textboxCtrl.scope.name].$name === "Disability Nature" ||
                    textboxCtrl.scope.form[textboxCtrl.scope.name].$name === "Training Specifications")) {
                decideValidity();
            }
        };
        $scope.$watch(getrequiredValue, textboxCtrl.onreqchange);

        function decideValidity() {

            //textboxCtrl.scope.form[textboxCtrl.scope.name].$touched = false;
            if (textboxCtrl.scope.required && (textboxCtrl.scope.value == "" || !angular.isDefined(textboxCtrl.scope.value))) {
                textboxCtrl.scope.form[textboxCtrl.scope.name].$setValidity('required',false);
            }
            else{
                textboxCtrl.scope.form[textboxCtrl.scope.name].$setValidity('required',true);
            }
            if (textboxCtrl.scope.usePattern && $scope.value && $scope.value.match && angular.isDefined($scope.pattern) && $scope.pattern != null && $scope.pattern.length > 0) {// if has a pattern associated then check if the new key pressed is valid
                var match = $scope.value.match($scope.regex);
                if (!match || match[0] != $scope.value) {
                    textboxCtrl.scope.form[textboxCtrl.scope.name].$setValidity('pattern',false);
                }
                else{
                    textboxCtrl.scope.form[textboxCtrl.scope.name].$setValidity('pattern',true);
                }
            }
            
            return textboxCtrl.scope.form[textboxCtrl.scope.name].$valid;
        }

        
        //////////////////CHECK FOR IF DISABLED VALUE IS ENTERED////////////////////////////////////

        if (!angular.isDefined(textboxCtrl.scope.disabled)) {
            textboxCtrl.scope.disabled = false; //by default no field is disabled unless explicitly mentioned in the directive
        }


        //////////////////CHECK FOR IF  TYPE  VALUE IS ENTERED///////////////////////////////////////////////////////////
        if (!angular.isDefined(textboxCtrl.scope.type)) {
            textboxCtrl.scope.type = "text";
        }

        //////////////////CHECK FOR IF PATTERN VALUE IS ENTERED IN GENERAL FOR TEXT TYPE/////////////////////////////////
        if (!angular.isDefined(textboxCtrl.scope.pattern)) {
            //if pattern is not defined
            var type = textboxCtrl.scope.type;

			/*['^[a-zA-Z]+$', // characters or alpha
			 "^[a-zA-Z0-9]+$", // alphanumeric
			 "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$", // email
			 "^[0-9]+$", // numbers or numeric only
			 "^[a-zA-Z 0-9\-,]+$",/// text or string or address
			 "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"],
			 */
            if (type == "alphabet") {
                let Pattern_Alphanumeric = $filter('translate')("Pattern_Alphanumeric");
                textboxCtrl.scope.pattern = Pattern_Alphanumeric;
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[0];

            }
            else if (type == "alpha") {
                let Pattern_Characters_Or_Aplha = $filter('translate')("Pattern_Alpha_WithoutSpace");
                textboxCtrl.scope.pattern = Pattern_Characters_Or_Aplha;
            }
            else if (type == "alphanumeric") {
                let Pattern_Characters_Or_Aplha = $filter('translate')("Pattern_Characters_Or_Aplha");
                textboxCtrl.scope.pattern = Pattern_Characters_Or_Aplha;
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[1];

            }
            else if (type == "email") {
                //textboxCtrl.scope.pattern = "[_A-Za-z0-9\.]+@{0,1}[A-Za-z0-9]*(.{0,1}[a-zA-Z]*){0,3}";//'^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$';
                //textboxCtrl.scope.type='text';
            }
            else if (type == "documentNumber") {
                var Document_Number = $filter('translate')("Document_Number");
                textboxCtrl.scope.pattern = Document_Number;
            }
            else if (type == "phone") {
                var Phone_Number = $filter('translate')("Phone_Number");
                textboxCtrl.scope.pattern = Phone_Number;
            }

            else if (type == "decimal") {
                // eslint-disable-next-line no-useless-escape
                textboxCtrl.scope.pattern = '/^\d+\.\d{0,2}$/';
            }

            else if (type == "number" || type == "integer" || type == "amount") {
                textboxCtrl.scope.value = parseFloat(textboxCtrl.scope.value ? textboxCtrl.scope.value : 0);
                var Pattern_Number = $filter('translate')("Pattern_Number");
                textboxCtrl.scope.pattern = Pattern_Number;
                // textboxCtrl.scope.pattern='[+|-]{0,1}[0-9]+';
                if (angular.isDefined(textboxCtrl.scope.precision) && textboxCtrl.scope.precision != null && textboxCtrl.scope.precision > 0) {
                    textboxCtrl.scope.pattern += '(\\.[0-9]{0,' + textboxCtrl.scope.precision + '}){0,1}';
                }
				/*if(angular.isDefined(textboxCtrl.scope.precision) && !isNaN(textboxCtrl.scope.precision) && !isNaN(textboxCtrl.scope.maxlength) )
                {
                    textboxCtrl.scope.pattern = '[0-9]{0,'+(parseInt(textboxCtrl.scope.maxlength)-parseInt(textboxCtrl.scope.precision))+'}.{0,1}[0-9]{0,'+textboxCtrl.scope.precision+'}'; //default pattern letters

                }*/
                // else{
                //    textboxCtrl.scope.pattern = '^(-|\+)?(([1-9][0-9]*)|(0))(?:\.[0-9]+)?$'; //default pattern letters
                // }


            }

            else if (type == "text" || type == "textarea" || type == "locationcapture") {
                var Pattern_Text = $filter('translate')("Pattern_Text");
                if (textboxCtrl.scope.patternName) {
                    Pattern_Text = $filter('translate')(textboxCtrl.scope.patternName);
                }

                textboxCtrl.scope.pattern = Pattern_Text;
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[4];

            }
            else if(type == "opentext") {
                textboxCtrl.scope.pattern = ''; //no pattern needed for open field
            }
            else if (type == "chpassword") {
                var Pattern_Password = $filter('translate')("Pattern_Password");
                textboxCtrl.scope.pattern = Pattern_Password;
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[5];
            }
            else if (type == "password") {
                textboxCtrl.scope.pattern = ''; // not sure if we need to apply any pattern to check password
            }
            else if (type == "address") {
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[5];
            }
            else if (type == "zipcode") {
                let Pattern_Number = $filter('translate')("Pattern_Number");
                textboxCtrl.scope.pattern = Pattern_Number;
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[3];
            }
            else if (type == "numeric") {
                let Pattern_Number = $filter('translate')("Pattern_Number");
                textboxCtrl.scope.pattern = Pattern_Number;
            }
            else {
                let Pattern_Characters_Or_Aplha = $filter('translate')("Pattern_Characters_Or_Aplha");
                textboxCtrl.scope.pattern = Pattern_Characters_Or_Aplha;
                // textboxCtrl.scope.pattern = userInputRestrictions.pattern[0]; //default pattern letters
            }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        $scope.hideRegularMessages = function () {
            return angular.isDefined($scope.dynamicField) || textboxCtrl.scope.showCustomMessage;
        }
        /*		var dynamic_patch=true;//we want the watch to change for sure the first time;
        
                function montiorDynamicField(){
                    if(dynamic_patch){
                        dynamic_patch=!dynamic_patch;
                        return !(!$scope.dynamicField.isValid && $scope.dynamicShow);//inverse of condition below, to make sure it differs the next time montior is called
                    }
                    return !$scope.dynamicField.isValid && $scope.dynamicShow;// return true if field not valid and error messages are enabled
                }
        
                function updateInputColor(newValue,oldValue){
                    try{
                        if(newValue){
                            $scope.form[$scope.dynamicField.form_name].$setValidity("required", false);
                            $scope.form[$scope.dynamicField.form_name].$setTouched(true);
                        }else{
                            $scope.form[$scope.dynamicField.form_name].$setValidity("required", true);
                            $scope.form[$scope.dynamicField.form_name].$setTouched(false);
                        }
                    }
                    catch(e){
                        dynamic_patch=true;
                    }
                }
        
                if(angular.isDefined($scope.dynamicField) && angular.isDefined($scope.dynamicShow)){
                    $scope.$watch(montiorDynamicField,updateInputColor);
                }*/


        $scope.type2 = $scope.type;
        if ($scope.type2 == "numeric" || $scope.type2 == "number" || $scope.type2 == "integer" || $scope.type2 == "amount") {
            $scope.type2 = "text";
        }
        else if ($scope.type == "textarea") {
            $scope.multiline = true;
        }
        if (angular.isDefined($scope.pattern) && $scope.pattern != null && $scope.pattern.length > 0) {
            $scope.regex = new RegExp($scope.pattern);
        }


        //if it is a formula driven value
        if (angular.isDefined($scope.hasFormula) && $scope.hasFormula == "true") {
            bindValueWithFormula();
        }
        //initialize disablility for first time


        if (angular.isDefined($scope.hasDisabledExpression) && $scope.hasDisabledExpression == "true") {
            bindDisablilityWithFormula();
        }
        if (angular.isDefined($scope.readonly)) {
            if ($scope.readonly == "true")
                textboxCtrl.scope.disabled = true;
            else
                textboxCtrl.scope.disabled = false;
        }
        function bindValueWithFormula() {
            function get() {
                return $scope.formula;
            }

            function update(f1, f2) {
                if (f1 != f2 || $scope.value != parseFloat(f1)) {
                    if ($scope.type != "number" && $scope.type != "numeric" && $scope.type != "amount")
                        $scope.value = f1;
                    else
                        $scope.value = parseFloat(f1);
                }
            }
            update($scope.formula);
            $scope.$watch(get, update);
        }

        function bindDisablilityWithFormula() {
            function get() {
                return $scope.readonly;
            }

            function update(f1, f2) {
                if (f1 != f2) {
                    delete $scope.value;
                    if (f1 == "true")
                        $scope.disabled = true;
                    else
                        $scope.disabled = false;
                }
            }

            $scope.$watch(get, update);
        }

    }


    // eslint-disable-next-line no-unused-vars
    function setupLengths($scope, vm) {
        if ($scope.type == 'text') {
            //do nothing for now
        }
        if ($scope.type == 'number' || $scope.type == 'numeric' || $scope.type == 'amount') {
            if (!isNaN($scope.minlength)) {
                $scope.min = parseFloat($scope.minlength);
                delete $scope.minlength;
            }
            if (!isNaN($scope.maxlength)) {
                $scope.max = parseFloat($scope.maxlength);
                delete $scope.maxlength;
            }
        }
    }
})();
